<template>
  <v-slide-x-reverse-transition>
    <div>
      <v-card class="elevation-5 provider-group-details vop-bg-whisper" v-show="isVisible">
        <div>
          <!-- Title -->
          <v-toolbar flat class="vop-bg-whisper">
            <v-toolbar-title class="subheading ttu font-weight-medium">
              <span v-if="isEditMode"> {{ messages.label.EDIT_PROVIDER_GROUP }}</span>
              <span v-else>{{ messages.label.ADD_PROVIDER_GROUP }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="hide()">
              <v-icon medium>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <!-- Error message -->
              <v-flex xs12 v-if="providerGroupError !== ''">
                <v-alert :value="
                true" type="error">
                  {{ providerGroupError }}
                </v-alert>
              </v-flex>
              <!-- Provider Group Form -->
              <v-flex xs8>
                <v-form>
                  <v-flex xs11>
                    <v-text-field v-model="providerGroup.title" :clearable="!isEditMode" :disabled="isEditMode"
                      v-validate="'required|max:100|account'" :error-messages="errors.collect('title')"
                      data-vv-name="title" data-vv-delay="500" :counter="100" :label="messages.label.TITLE"
                      :loading="validatingAccount" required>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11>
                    <v-text-field v-model="providerGroup.dropLocation" clearable v-validate="'required|dropLocation'"
                      :error-messages="errors.collect('dropLocation')" data-vv-name="dropLocation" data-vv-delay="500"
                      :label="messages.label.DROP_LOCATION" :loading="validatingDropLocation" required>
                    </v-text-field>
                  </v-flex>
                  <v-layout row align-center>
                    <v-flex xs11>
                      <v-select v-model="providerGroup.translator" :label="messages.label.TRANSLATOR"
                        v-validate="'required'" :error-messages="errors.collect('translator')" data-vv-name="translator"
                        :items="translatorsList" item-text="title" item-value="value" required>
                      </v-select>
                    </v-flex>
                    <v-flex xs1>
                      <v-tooltip slot="append" bottom>
                        <v-icon slot="activator" class="pointer" small color="grey">help</v-icon>
                        {{ messages.info.TRANSLATOR_HELP }}
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center>
                    <v-flex xs11>
                      <v-text-field v-model="providerGroup.plannerHeaderStartIdentifier" clearable
                        v-validate="'required|max:5|alpha_num'"
                        :error-messages="errors.collect('headerStartIdentifier')" data-vv-name="headerStartIdentifier"
                        :label="messages.label.HEADER_START_IDENTIFIER"
                        :hint="messages.info.HEADER_START_IDENTIFIER_HINT" required>
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-tooltip slot="append" bottom>
                        <v-icon slot="activator" small class="pointer" color="grey">help</v-icon>
                        {{ messages.info.HEADER_START_IDENTIFIER_HELP }}
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center>
                    <v-flex xs11>
                      <v-text-field v-model="providerGroup.plannerDataStartIdentifier" clearable
                        v-validate="'required|max:5|alpha_num'" :error-messages="errors.collect('dataStartIdentifier')"
                        data-vv-name="dataStartIdentifier" :label="messages.label.DATA_START_IDENTIFIER"
                        :hint="messages.info.DATA_START_IDENTIFIER_HINT" required>
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-tooltip slot="append" bottom>
                        <v-icon slot="activator" small class="pointer" color="grey">help</v-icon>
                        {{ messages.info.DATA_START_IDENTIFIER_HELP }}
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
              <v-flex xs12 class="mt-2">
                <!-- Providers list link -->
                <v-layout row wrap>
                  <v-flex xs12 v-if="isEditMode">
                    <v-btn color="
                        primary" flat class="ma-0" @click="showProvidersList()" small>{{ messages.label.PROVIDER_LIST }}
                      <v-icon right small>open_in_new</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <h2 class="body-2 ttu pl-2">{{ messages.label.TEMPLATES }}</h2>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right" v-if="isEditMode">
                    <v-btn color="primary" flat class="ma-0" @click="showCreateTemplateModal()">
                      <v-icon left>add_circle</v-icon><span>{{ messages.label.CREATE }}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <!-- Templates list -->
                <v-data-table :headers="templateTableHeaders" :items="templateList" hide-actions
                  :loading="templatesListLoading" v-if="isEditMode">
                  <!-- Items -->
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs-left">{{ props.item.title }}</td>
                      <td class="text-xs-left">{{ props.item.description }}</td>
                      <td class="text-xs-left">{{ !props.item.disabled }}</td>
                      <td>
                        <v-menu bottom left>
                          <v-btn icon slot="activator">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile @click="showEditTemplateModal(props.item)">
                              <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showTestTemplateModal()" v-if="isFeatureVisible('templateManagement')">
                              <v-list-tile-title>{{ messages.label.TEST }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showDeleteTemplate(props.item)" color="error">
                              <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                  <!-- No Data -->
                  <template slot="no-data">
                    <v-alert color="info" v-if="templatesListError" :value="true" class="black--text vop-bg-whis"
                      icon="info">
                      {{ messages.info.NO_TEMPLATES }}
                    </v-alert>
                    <v-alert color="info" v-else :value="true" class="black--text vop-bg-whis" icon="info">
                      {{ messages.info.NO_TEMPLATES }}
                    </v-alert>
                  </template>
                </v-data-table>
                <v-alert color="info" :value="true" class="black--text" icon="info" v-else>
                  {{ messages.info.SAVE_PROVIDER_GROUP }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-card-text>
        </div>
        <v-card-actions class="px-3">
          <v-spacer />
          <!-- Delete Provider Group  -->
          <v-dialog v-model="deleteDialog" width="500" v-if="isEditMode">
            <v-btn color="error" slot="activator">
              {{ messages.label.DELETE }}
            </v-btn>
            <v-card>
              <v-card-title class="subheading ttu">
                {{ messages.label.DELETE_PROVIDER_GROUP }}
              </v-card-title>
              <v-card-text>
                <p>{{ messages.info.DELETE_PROVIDER_GROUP_1 }} <b>{{ providerGroup.title }}</b> ? </p>
                <p v-html="messages.info.DELETE_PROVIDER_GROUP_2"></p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
                  {{ messages.label.CANCEL }}
                </v-btn>
                <v-btn color="error" :disabled="deletingProviderGroup" :loading="deletingProviderGroup"
                  @click="deleteProviderGroup">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" class="ml-2" :disabled="updatingProviderGroup" :loading="updatingProviderGroup"
            v-if="isEditMode" @click="updateProviderGroup">
            {{ messages.label.SAVE }}
          </v-btn>
          <v-btn color="primary" class="ml-2" :disabled="addingProviderGroup" :loading="addingProviderGroup"
            @click="addProviderGroup" v-else>
            {{ messages.label.ADD }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- Dialogs -->
      <ManageTemplate />
      <TestTemplate />
      <ProvidersListDialog />
      <!-- Delete template Dialog -->
      <v-dialog v-model="deleteTemplateDialog" width="500">
        <v-card>
          <v-card-title class="headline font-weight-light">
            {{ messages.label.DELETE_TEMPLATE }}
          </v-card-title>
          <v-card-text>
            <p>{{ messages.info.DELETE_TEMPLATE_1 }} <b>{{ selectedTemplate.title }}</b> ? </p>
            <p v-html="messages.info.DELETE_TEMPLATE_2"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1 white--text" @click="cancelDeleteTemplate">
              {{ messages.label.CANCEL }}
            </v-btn>
            <v-btn color="error" :disabled="deletingTemplate" :loading="deletingTemplate" @click="deleteTemplate">
              {{ messages.label.DELETE }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="secondary" @click.native="snackbar.show = false">
            {{ messages.label.OK }}
          </v-btn>
        </v-snackbar>
      </v-flex>
    </div>
  </v-slide-x-reverse-transition>
</template>

<script>
import { Validator } from "vee-validate"
import { mapActions, mapGetters, mapState } from "vuex"
import ProvidersService from "@/Providers/ProvidersService"
import AppService from "@/AppService"
import * as providersDataService from "@/Providers/ProvidersDataService"
import ManageTemplate from "@/Providers/ProviderGroups/ManageTemplate"
import TestTemplate from "@/Providers/ProviderGroups/TestTemplate"
import ProvidersListDialog from "@/Providers/ProviderGroups/ProvidersListDialog"
import messages from "@/Providers/messages.json"
import { GET_PROVIDER_GROUPS } from "@/store/constants/action-types"
import {
  VOD_SYCN_TEMPLATE_DATA_SERVICE_URL,
  VOD_SYCN_PREINGEST_DATA_SERVICE_URL
} from "@/store/constants/getter-types"
import * as utils from "@/Shared/utils"
import {
  DEV_HOST,
  TEST_HOST,
  LOCALHOST,
  POLARIS_ACCOUNT_TITLE_PREFIX_PREVIEW,
  POLARIS_ACCOUNT_TITLE_PREFIX_PROD
} from "@/Shared/constants"

/**
 * initialData
 */
function initialData(instance) {
  return {
    isEditMode: false,
    isVisible: false,
    valid: false,
    translatorsList: instance.retrieveTranslators(),
    providerGroup: {},
    providerGroupError: "",
    addingProviderGroup: false,
    updatingProviderGroup: false,
    deletingProviderGroup: false,
    validatingDropLocation: false,
    validatingAccount: false,
    deleteDialog: false,
    deleteTemplateDialog: false,
    templateTableHeaders: instance.getTemplateTableHeaders(),
    templateList: [],
    providersList: [],
    templatesListLoading: false,
    templatesListError: false,
    dictionary: instance.getValidationDictionary(),
    selectedTemplate: {},
    deletingTemplate: false,
    snackbar: {
      show: false,
      timeout: 5000,
      message: "",
      color: "error"
    }
  }
}

export default {
  name: "ProviderGroupDetails",
  components: {
    ManageTemplate,
    TestTemplate,
    ProvidersListDialog
  },
  $_veeValidate: {
    validator: "new"
  },
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState([
      "mpxParentAccount"
    ]),
    ...mapGetters([
      VOD_SYCN_TEMPLATE_DATA_SERVICE_URL, VOD_SYCN_PREINGEST_DATA_SERVICE_URL
    ])
  },
  methods: {
    ...mapActions([
      GET_PROVIDER_GROUPS
    ]),

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * isFeatureVisible - Identify if a feature is visible
     * @param {string} featureName
     * @returns {Boolean}
     */
    isFeatureVisible(featureName) {
      return AppService.isFeatureVisible(featureName)
    },

    /**
     * hide - Hide side sheet view
     */
    hide() {
      this.isVisible = false
      this.resetProviderGroupData()
      ProvidersService.$emit("event:hideProviderGroupDetailsSheet")
    },

    /**
     * show - Show side sheet view
     * @param {object} providerGroup
     */
    show(providerGroup) {
      this.resetProviderGroupData()
      // Wait before updating form
      this.$nextTick(() => {
        this.$validator.reset()
        if (!this.$lodash.isUndefined(providerGroup)) {
          this.isEditMode = true
          this.providerGroup = this.$lodash.cloneDeep(providerGroup)
          this.retrieveTemplateList(providerGroup.title, providerGroup.ownerId)
        } else {
          this.isEditMode = false
        }
        this.isVisible = true
      })
    },

    /**
     * retrieveTemplateList - Retreive templates for selected provider group
     * @param {string} providerGroupTitle
     */
    retrieveTemplateList(providerGroupTitle, providerGroupOwnerId) {
      this.templateList = []
      this.templatesListLoading = true
      let templatesQueryObject = {
        byProviderGroup: providerGroupTitle,
        byOwnerId: providerGroupOwnerId
      }
      providersDataService
        .retrieveTemplates(templatesQueryObject, this.VOD_SYCN_TEMPLATE_DATA_SERVICE_URL)
        .then((response) => {
          this.templateList = response.data
        }).catch((error) => {
          this.templateList = []
          if (this.$lodash.has(error, ["response", "data"])) {
            // TODO: Display error
            console.log("retrieveTemplateList", error.response.data.description)
          }
        })
        .finally(() => {
          this.templatesListLoading = false
        })
    },

    /**
      * showProvidersList - Show providers list dialog
      */
    showProvidersList() {
      let providerGroupId = this.providerGroup.id
      ProvidersService.$emit("event:showProvidersListDialog", providerGroupId)
    },

    /**
     * Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters"
          },
          dropLocation: {
            required: () => "Drop Location can't be empty"
          },
          translator: {
            required: "Please select a Translator"
          },
          headerStartIdentifier: {
            required: () => "Header Start Identifier can't be empty",
            max: "Header Start Identifier may not be greater than 5 characters",
            alpha_num:
              "Header Start Identifier may only contain alphabetic characters or numbers"
          },
          dataStartIdentifier: {
            required: () => "Data Start Identifier can't be empty",
            max: "Data Start Identifier may not be greater than 5 characters",
            alpha_num:
              "Data Start Identifier may only contain alphabetic characters or numbers"
          }
        }
      }
    },

    /**
    * getTemplateTableHeaders  - Construct array of objects to show table headers
    * @return {array}
    */
    getTemplateTableHeaders() {
      let headers = [
        {
          text: messages.label.TH_NAME,
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: messages.label.TH_DESCRIPTION,
          align: "left",
          value: "description",
          sortable: false
        },
        {
          text: messages.label.TH_ENABLED,
          align: "left",
          value: "disabled",
          sortable: false
        },
        {
          text: "",
          sortable: false
        }
      ]
      return headers
    },

    /**
     * resetProviderGroupData - Reset data
     */
    resetProviderGroupData() {
      this.providerGroup = {}
      this.providerGroupError = ""
    },

    /**
     * retrieveTranslators - Retrieve list of translators
     * @returns {array}
     */
    retrieveTranslators() {
      let translators = [
        {
          title: "Row Based Translator",
          value: "translateRowBasedPlanner"
        }
      ]
      return translators
    },

    /**
     * accountValidator - Async validation for account title
     * @returns {Promise}
     */
    accountValidator() {
      this.validatingAccount = true
      return this.isAccountExists().then((isInUse) => {
        this.validatingAccount = false
        if (isInUse) {
          return Promise.resolve({
            valid: false,
            data: {
              message:
                "Account with this title already exists, Choose a different title"
            }
          })
        } else {
          return Promise.resolve({
            valid: true
          })
        }
      })
    },

    /**
     * isAccountExists - Check if account already exists
     * @returns {Promise}
     */
    isAccountExists() {
      let accountTitleWithPrefix = this.getMPXAccountTitleWithPrefix(this.providerGroup.title)
      return providersDataService
        .isAccountExits(accountTitleWithPrefix)
        .then((response) => {
          let accountsCount = response.data.entryCount
          if (accountsCount > 0) {
            if (this.isEditMode) {
              let providerGroupOwnerId = this.providerGroup.ownerId
                .split("/")
                .pop()
              let accountId = response.data.entries[0].id.split("/").pop()
              if (providerGroupOwnerId === accountId) {
                return Promise.resolve(false)
              } else {
                return Promise.resolve(true)
              }
            } else {
              return Promise.resolve(true)
            }
          } else {
            return Promise.resolve(false)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * getMPXAccountTitleWithPrefix
     */
    getMPXAccountTitleWithPrefix(displayTitle) {
      let accountTitle = ""
      const serverUrl = utils.getServerUrl()
      if (
        serverUrl.indexOf(LOCALHOST) > -1 ||
        serverUrl.indexOf(DEV_HOST) > -1 ||
        serverUrl.indexOf(TEST_HOST) > -1
      ) {
        accountTitle = POLARIS_ACCOUNT_TITLE_PREFIX_PREVIEW + displayTitle
      } else {
        accountTitle = POLARIS_ACCOUNT_TITLE_PREFIX_PROD + displayTitle
      }
      return accountTitle
    },

    /**
     * dropLocationValidator - Async validation for drop location
     * @returns {Promise}
     */
    dropLocationValidator() {
      this.validatingDropLocation = true
      return this.isDropLocationInUse().then((isInUse) => {
        this.validatingDropLocation = false
        if (isInUse) {
          return Promise.resolve({
            valid: false,
            data: {
              message: "Drop Location is already in use"
            }
          })
        } else {
          return Promise.resolve({
            valid: true
          })
        }
      })
    },

    /**
     * isDropLocationInUse - Check if drop location is already in use
     * @returns {Promise}
     */
    isDropLocationInUse() {
      return providersDataService
        .isDropLocationInUse(
          this.providerGroup.dropLocation,
          this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          let providerGroupsCount = response.data.entryCount
          if (providerGroupsCount > 0) {
            if (
              this.isEditMode &&
              this.providerGroup.id === response.data.entries[0].id
            ) {
              return Promise.resolve(false)
            } else {
              return Promise.resolve(true)
            }
          } else {
            return Promise.resolve(false)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * addProviderGroup - Add new provider group
     */
    addProviderGroup() {
      this.$validator.validateAll().then((result) => {
        let accountTitleWithPrefix = this.getMPXAccountTitleWithPrefix(this.providerGroup.title)
        this.providerGroup.accountTitle = accountTitleWithPrefix
        if (result) {
          this.addingProviderGroup = true
          return providersDataService
            .addProviderGroup(this.providerGroup,
              this.mpxParentAccount.id,
              this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
            .then((response) => {
              this.resetProviderGroupData()
              ProvidersService.$emit("event:refreshProviderGroupsList", "add", response.data.id)
              // Snack bar
              this.snackbar.show = true
              this.snackbar.color = "success"
              this.snackbar.message = this.messages.info.PG_CREATE_SUCCESS
              return response
            })
            .catch((error) => {
              let response = error.response.data
              if (response.isException) {
                this.providerGroupError = response.description
              }
              return Promise.reject(error)
            }).finally(() => {
              this.addingProviderGroup = false
              this.GET_PROVIDER_GROUPS() // Update store
            })
        }
      })
    },

    /**
     * updateProviderGroup - Update provider group details
     */
    updateProviderGroup() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updatingProviderGroup = true
          return providersDataService
            .updateProviderGroup(
              this.providerGroup,
              this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
            .then((response) => {
              ProvidersService.$emit("event:refreshProviderGroupsList", "update", this.providerGroup.id)
              this.resetProviderGroupData()
              // Snack bar
              this.snackbar.show = true
              this.snackbar.color = "success"
              this.snackbar.message = this.messages.info.PG_UPDATE_SUCCESS
              return response
            })
            .catch((error) => {
              let response = error.response.data
              if (response.isException) {
                this.providerGroupError = response.description
              }
              return Promise.reject(error)
            })
            .finally(() => {
              this.updatingProviderGroup = false
              this.GET_PROVIDER_GROUPS() // Update store
            })
        }
      })
    },

    /**
     * deleteProviderGroup - Delete provider group
     */
    deleteProviderGroup() {
      this.deletingProviderGroup = true
      let providerGroupOwnerId = this.providerGroup.ownerId.split("/").pop()
      let providerGroupId = this.providerGroup.id.split("/").pop()
      return providersDataService
        .deleteProviderGroup(providerGroupId, providerGroupOwnerId, this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          this.isVisible = false
          this.resetProviderGroupData()
          ProvidersService.$emit("event:refreshProviderGroupsList", "delete")
          // Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.PG_DELETE_SUCCESS
          return response
        })
        .catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.providerGroupError = response.description
          }
          return Promise.reject(error)
        })
        .finally(() => {
          this.deleteDialog = false
          this.deletingProviderGroup = false
          this.GET_PROVIDER_GROUPS() // Update store
        })
    },

    /**
     * getProviderGroup - Retreive provider group by id
     * @param {string} providerGroupId
     * @returns {Promise}
     */
    getProviderGroup(providerGroupId) {
      let providerGroupsQueryObject = {
        byId: providerGroupId
      }
      let providerGroup = {}
      return providersDataService
        .retrieveProviderGroups(providerGroupsQueryObject,
          this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          if (!this.$lodash.isUndefined(response.data.entries)) {
            providerGroup = response.data.entries[0]
          }
          return providerGroup
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * showDeleteTemplate - Display delete template dialog
     * @param {object} templateObj
     */
    showDeleteTemplate(templateObj) {
      this.selectedTemplate = templateObj
      this.deleteTemplateDialog = true
    },

    /**
     * deleteTemplate - Delete Template
     * @returns {Promise}
     */
    deleteTemplate() {
      this.deletingTemplate = true
      let templateId = this.selectedTemplate.id
      return providersDataService
        .deleteTemplate(templateId, this.VOD_SYCN_TEMPLATE_DATA_SERVICE_URL)
        .then((response) => {
          // TODO: Show snackbar msg
          ProvidersService.$emit("event:templateDeleted")
          return response
        })
        .catch((error) => {
          // TODO: Handle error
          return Promise.reject(error)
        })
        .finally(() => {
          this.deletingTemplate = false
          this.deleteTemplateDialog = false
          ProvidersService.$emit("event:refreshTemplateList")
        })
    },

    /**
     * Hide Delete template modal
     */
    cancelDeleteTemplate() {
      this.selectedTemplate = {}
      this.deleteTemplateDialog = false
    },

    /**
     * showCreateTemplateModal - shows create template modal
     */
    showCreateTemplateModal() {
      ProvidersService.$emit("event:showManageTemplateModal", this.providerGroup)
    },

    /**
     * showEditTemplateModal - shows edit template modal
     * @param {object}
     */
    showEditTemplateModal(templateObject) {
      ProvidersService.$emit("event:showManageTemplateModal", this.providerGroup, templateObject)
    },

    /**
     * Test template
     */
    showTestTemplateModal() {
      ProvidersService.$emit("event:showTestTemplateModal", this.providerGroup, this.templateList)
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)

    // Custom validators
    Validator.extend("dropLocation", {
      validate: this.dropLocationValidator,
      getMessage: (field, params, data) => data.message
    })
    Validator.extend("account", {
      validate: this.accountValidator,
      getMessage: (field, params, data) => data.message
    })
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    ProvidersService.$on("event:showProviderGroupDetailsSheet", this.show)
    ProvidersService.$on("event:refreshTemplateList", () => {
      // TODO: Update to use a function reference instead of inline function
      this.retrieveTemplateList(this.providerGroup.title)
    })
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    ProvidersService.$off(
      "event:showProviderGroupDetailsSheet",
      this.show
    )
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.provider-group-details {
  min-height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/Providers/ProviderGroups/ProviderGroupDetails.vue